import React from 'react';
import PropTypes from 'prop-types';
import { FilterGroup, RadioFilter } from '@lt/components';

const RadioFilterGroup = ({
  data,
  isMobile,
  onChange,
  onClear,
  showClearBtn,
  Filter,
  filterName,
  filterLabel,
  LabelComponent,
  className,
}) => (
  <FilterGroup
    className={className}
    label={Filter ? Filter.filterLabel : filterLabel}
    onClear={() => onClear(Filter ? Filter.filterName : filterName)}
    showClearBtn={showClearBtn}
    isMobile={isMobile}
  >
    <RadioFilter
      LabelComponent={LabelComponent}
      name={Filter ? Filter.filterName : filterName}
      items={data}
      onChange={onChange}
      isMobile={isMobile}
    />
  </FilterGroup>
);

RadioFilterGroup.defaultProps = {
  className: '',
  showClearBtn: false,
  LabelComponent: undefined,
  isMobile: false,
  onClear: Function.prototype,
};
RadioFilterGroup.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  Filter: PropTypes.shape({
    filterName: PropTypes.string,
    filterLabel: PropTypes.string,
  }),
  LabelComponent: PropTypes.node,
  showClearBtn: PropTypes.bool,
  isMobile: PropTypes.bool,
  filterLabel: PropTypes.string,
  filterName: PropTypes.string,
};

export default React.memo(RadioFilterGroup);
